// Parâmetros do estoque: tolerância da NF, saldo negativo e os limites de cada insight. Todos
// leem; só admin edita (backend/services/estoque/parametros.py guarda os padrões).
import { useEffect, useState } from "react";
import { Check } from "lucide-react";
import { getEstoqueParametros, getRoleFromToken, putEstoqueParametro } from "../../api";
import { permissoesEstoque } from "../../constants/estoque";
import EstoqueLayout from "./EstoqueLayout";
import { mensagemErro } from "./comum";
import { AvisoErro, NumeroInput, btnStyle, numeroParaInput, palette, parseNumero } from "./ui";

function LinhaParametro({ C, p, podeEditar, onSalvo }) {
  const inicial = p.tipo === "bool" ? p.valor : numeroParaInput(p.valor);
  const [valor, setValor] = useState(inicial);
  const [status, setStatus] = useState("");
  const [erro, setErro] = useState(null);
  useEffect(() => { setValor(inicial); }, [inicial]);
  const alterado = valor !== inicial;

  async function salvar(novo = valor) {
    const enviar = p.tipo === "bool" ? novo : parseNumero(novo);
    if (enviar === null || enviar === "") { setErro(new Error("Informe um número")); return; }
    setErro(null);
    try {
      onSalvo(await putEstoqueParametro(p.chave, enviar));
      setStatus("salvo");
    } catch (e) {
      setErro(e);
    }
  }

  const sufixo = p.chave.endsWith("_pct") ? "%" : p.chave.endsWith("_dias") ? "dias" : p.chave === "nf_tolerancia_valor" ? "R$" : "";
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 12, padding: "12px 14px", borderTop: `1px solid ${C.border}`, flexWrap: "wrap" }}>
      <div style={{ flex: "1 1 280px", fontSize: 13, color: C.text, lineHeight: 1.4 }}>
        {p.descricao}
        {erro && <div style={{ color: C.danger, fontSize: 12, marginTop: 2 }}>{mensagemErro(erro)}</div>}
      </div>
      {p.tipo === "bool" ? (
        <label style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 13, cursor: podeEditar ? "pointer" : "default" }}>
          <input type="checkbox" checked={valor === "true"} disabled={!podeEditar} style={{ width: 20, height: 20 }}
            onChange={(e) => { const v = e.target.checked ? "true" : "false"; setValor(v); salvar(v); }} />
          {valor === "true" ? "Sim" : "Não"}
          {status === "salvo" && <Check size={16} color={C.success} />}
        </label>
      ) : (
        <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
          {sufixo === "R$" && <span style={{ fontSize: 12, color: C.muted }}>R$</span>}
          <NumeroInput C={C} casas={p.tipo === "int" ? 0 : 2} value={valor} disabled={!podeEditar} style={{ width: 90 }}
            onChange={(v) => { setValor(v); setStatus(""); }} onKeyDown={(e) => e.key === "Enter" && alterado && salvar()} aria-label={p.descricao} />
          {sufixo && sufixo !== "R$" && <span style={{ fontSize: 12, color: C.muted, width: 30 }}>{sufixo}</span>}
          {podeEditar && (
            <button onClick={() => salvar()} disabled={!alterado} aria-label="Salvar parâmetro"
              style={{ ...btnStyle(alterado ? C.brand : status === "salvo" ? C.success : C.border), width: 42, padding: 0, opacity: alterado || status === "salvo" ? 1 : 0.5 }}>
              <Check size={16} />
            </button>
          )}
        </div>
      )}
    </div>
  );
}

export default function ParametrosView() {
  const [isLight, setIsLight] = useState(true);
  const C = palette(isLight);
  const perm = permissoesEstoque(getRoleFromToken());
  const [params, setParams] = useState([]);
  const [erro, setErro] = useState("");
  useEffect(() => { getEstoqueParametros().then(setParams).catch((e) => setErro(e.message)); }, []);

  const grupos = params.reduce((acc, p) => ({ ...acc, [p.grupo]: [...(acc[p.grupo] || []), p] }), {});
  const atualizar = (novo) => setParams((ps) => ps.map((p) => (p.chave === novo.chave ? novo : p)));

  return (
    <EstoqueLayout titulo="Parâmetros do Estoque" isLight={isLight} setIsLight={setIsLight}>
      <AvisoErro C={C} onClose={() => setErro("")}>{erro}</AvisoErro>
      {!perm.admin && <div style={{ fontSize: 12, color: C.muted, marginBottom: 12 }}>Somente leitura — só o administrador altera os parâmetros.</div>}
      <div style={{ display: "flex", flexDirection: "column", gap: 16, maxWidth: 820 }}>
        {Object.entries(grupos).map(([grupo, lista]) => (
          <section key={grupo} style={{ background: C.card, border: `1px solid ${C.border}`, borderRadius: 12, overflow: "hidden" }}>
            <h3 style={{ margin: 0, padding: "12px 14px", fontSize: 14, background: C.bgActive }}>{grupo}</h3>
            {lista.map((p) => <LinhaParametro key={p.chave} C={C} p={p} podeEditar={perm.admin} onSalvo={atualizar} />)}
          </section>
        ))}
      </div>
    </EstoqueLayout>
  );
}
